// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"f525b174","787":"ead33d1f"}[chunkId] + ".chunk.js";
};